var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.697,
    height: 14.325,
    viewBox: "0 0 7.697 14.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Arrow_2333164",
    transform: "translate(7.697) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35458",
    "data-name": "Group 35458",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63867",
    "data-name": "Path 63867",
    d: "M6.541.246.257,6.24a.841.841,0,0,0,0,1.211.936.936,0,0,0,1.265,0l5.64-5.4,5.64,5.4a.935.935,0,0,0,1.265,0,.841.841,0,0,0,0-1.211L7.806.246A.935.935,0,0,0,6.541.246Z",
    fill: "#233d64",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowBtn);
export default __webpack_public_path__ + "static/media/rightArrowBtn.8c2b75f2f0c281edd6892e2bf5c5ae79.svg";
export { ForwardRef as ReactComponent };